import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import { useStaticQuery, graphql } from 'gatsby'

import defaultShareImg from '@/images/share.jpg'

function SEO({
  description,
  lang,
  meta,
  title,
  img,
  slug,
  structuredData,
  type = 'website',
  user,
  googletag,
  keywords,
}) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            url
            author
            domain
          }
        }
      }
    `,
  )

  const striphtml = str => str.replace(/<(?:.|\n)*?>/gm, '')

  const metaDescription = striphtml(
    description ? description : site.siteMetadata.description,
  )
  const metaImg = img ? img : defaultShareImg
  const postslug = slug ? slug : ''
  const fullurl = `${site.siteMetadata.url}${postslug}${
    postslug.endsWith('/') ? '' : '/'
  }`

  return (
    <Helmet>
      <html lang={lang} />
      <title>
        {title ? `${title} - ` : ''}
        {site.siteMetadata.title}
      </title>
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={keywords ? keywords : ''} />

      <meta
        property="og:title"
        content={`${title ? `${title} - ` : ''}${site.siteMetadata.title}`}
      />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullurl} />
      <meta
        property="og:image"
        content={`${site.siteMetadata.domain}${metaImg}`}
      />
      <meta property="twitter:card" content={`summary_large_image`} />
      <meta property="twitter:creator" content={site.siteMetadata.author} />
      <meta
        property="twitter:title"
        content={`${title ? `${title} - ` : ''}${site.siteMetadata.title}`}
      />
      <meta property="twitter:description" content={metaDescription} />
      <meta
        property="twitter:image"
        content={`${site.siteMetadata.domain}${metaImg}`}
      />
      {googletag && <script>{googletag}</script>}
    </Helmet>
  )
}

SEO.defaultProps = {
  lang: `es`,
  meta: [],
  description: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
}

export default SEO
